(function () {
  'use strict';

  function init(root) {
    if (!root || root.dataset.ornavoReady === 'true') return;
    root.dataset.ornavoReady = 'true';

    var mobileMenu = root.querySelector('[data-ornavo-mobile-menu]');
    var overlay = root.querySelector('[data-ornavo-overlay]');
    var openButton = root.querySelector('[data-ornavo-menu-open]');
    var closeButton = root.querySelector('[data-ornavo-menu-close]');
    var lastFocus = null;

    function setMobile(open) {
      if (!mobileMenu || !overlay || !openButton) return;
      if (open) {
        lastFocus = document.activeElement;
        mobileMenu.hidden = false;
        overlay.hidden = false;
        requestAnimationFrame(function () {
          mobileMenu.classList.add('is-open');
          overlay.classList.add('is-open');
        });
        openButton.setAttribute('aria-expanded', 'true');
        document.documentElement.classList.add('ornavo-menu-open');
        if (closeButton) closeButton.focus();
      } else {
        mobileMenu.classList.remove('is-open');
        overlay.classList.remove('is-open');
        openButton.setAttribute('aria-expanded', 'false');
        document.documentElement.classList.remove('ornavo-menu-open');
        window.setTimeout(function () {
          mobileMenu.hidden = true;
          overlay.hidden = true;
        }, 220);
        if (lastFocus && lastFocus.focus) lastFocus.focus();
      }
    }

    if (openButton) openButton.addEventListener('click', function () { setMobile(true); });
    if (closeButton) closeButton.addEventListener('click', function () { setMobile(false); });
    if (overlay) overlay.addEventListener('click', function () { setMobile(false); });
    if (mobileMenu) {
      mobileMenu.querySelectorAll('.js-modal-open-search-modal, .js-drawer-open-cart').forEach(function (control) {
        control.addEventListener('click', function () { setMobile(false); });
      });
    }

    root.querySelectorAll('[data-ornavo-mobile-tab]').forEach(function (tab) {
      tab.addEventListener('click', function () {
        var id = tab.getAttribute('data-ornavo-mobile-tab');
        root.querySelectorAll('[data-ornavo-mobile-tab]').forEach(function (item) {
          var active = item === tab;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        root.querySelectorAll('[data-ornavo-mobile-panel]').forEach(function (panel) {
          var active = panel.getAttribute('data-ornavo-mobile-panel') === id;
          panel.hidden = !active;
          panel.classList.toggle('is-active', active);
        });
      });
    });

    var desktopItems = root.querySelectorAll('[data-ornavo-desktop-item]');
    var hoverOpenTimer = null;
    var hoverCloseTimer = null;
    function closeDesktop(except) {
      desktopItems.forEach(function (item) {
        if (item === except) return;
        var button = item.querySelector('[data-ornavo-desktop-toggle]');
        var panel = item.querySelector('[data-ornavo-mega-panel]');
        item.classList.remove('is-open');
        if (button) button.setAttribute('aria-expanded', 'false');
        if (panel) panel.hidden = true;
      });
      if (!except && overlay) {
        overlay.classList.remove('is-desktop-open');
        overlay.hidden = true;
      }
    }

    function setDesktop(item, open) {
      var button = item.querySelector('[data-ornavo-desktop-toggle]');
      var panel = item.querySelector('[data-ornavo-mega-panel]');
      if (!button || !panel) return;
      closeDesktop(open ? item : null);
      item.classList.toggle('is-open', open);
      button.setAttribute('aria-expanded', open ? 'true' : 'false');
      panel.hidden = !open;
      if (overlay) {
        overlay.hidden = !open;
        overlay.classList.toggle('is-desktop-open', open);
      }
    }

    desktopItems.forEach(function (item) {
      var button = item.querySelector('[data-ornavo-desktop-toggle]');
      if (!button) return;
      button.addEventListener('click', function () {
        window.clearTimeout(hoverOpenTimer);
        window.clearTimeout(hoverCloseTimer);
        setDesktop(item, !item.classList.contains('is-open'));
      });
      item.addEventListener('mouseenter', function () {
        if (!window.matchMedia('(min-width: 990px)').matches) return;
        window.clearTimeout(hoverCloseTimer);
        hoverOpenTimer = window.setTimeout(function () { setDesktop(item, true); }, 90);
      });
      item.addEventListener('mouseleave', function () {
        if (!window.matchMedia('(min-width: 990px)').matches) return;
        window.clearTimeout(hoverOpenTimer);
        hoverCloseTimer = window.setTimeout(function () { setDesktop(item, false); }, 180);
      });
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Tab' && mobileMenu && !mobileMenu.hidden) {
        var focusable = mobileMenu.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])');
        if (focusable.length) {
          var first = focusable[0];
          var last = focusable[focusable.length - 1];
          if (event.shiftKey && document.activeElement === first) {
            event.preventDefault();
            last.focus();
          } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault();
            first.focus();
          }
        }
      }
      if (event.key !== 'Escape') return;
      if (mobileMenu && !mobileMenu.hidden) setMobile(false);
      closeDesktop();
    });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('.ornavo-header-root').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
})();